<!-- 设备管理 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="option">
        <el-button type="primary" @click="addStatus = true">添加</el-button>
        <el-input
          type="text"
          placeholder="油枪号"
          v-model="keyword"
          style="width:260px;margin:0 10px 0 40px"
          clearable
        />
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>
      <el-table
        :data="tableList"
        height="calc(100% - 120px)"
        v-loading="loading"
        :header-cell-style="setTableHeader"
      >
        <!-- <el-table-column label="id" prop="id"></!-->
        -->
        <el-table-column label="油枪号" prop="name"></el-table-column>
        <el-table-column label="关联产品" prop="goods.name"></el-table-column>
        <el-table-column label="原价（零售价格）" prop="goods.mktprice"></el-table-column>
        <el-table-column label="售价" prop="goods.price"></el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
        <el-table-column label="创建时间" prop="goods.create_time"></el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--添加油枪-->
      <el-dialog title="添加油枪" width="30%" :visible.sync="addStatus">
        <el-form :model="formData" ref="formData" label-width="80px">
          <el-form-item label="油枪号">
            <!-- <el-input
							v-model="formData.name"
							class="input_Box_medium"
							@blur="inputName(1)"
						>
							<i slot="suffix">号油枪</i>
						</el-input>
            <div style="color: #999">油枪号只能输入数字</div>-->
            <el-select v-model="formData.name" class="input_Box_medium">
              <el-option v-for="item in numberList" :key="item" :value="item" :label="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="绑定油品">
            <el-select v-model="formData.goods_id" placeholder="请选择产品" class="input_Box_medium">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disable"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="formData.remark" class="input_Box_medium"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addStatus = false">取 消</el-button>
          <el-button type="primary" @click="AddEquip">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <!--修改-->
      <el-dialog :visible.sync="showEdit" title="修改油枪信息" @close="showEdit = false" width="500px">
        <el-form :model="editForm" label-width="70px">
          <el-form-item label="油枪号">
            <el-select v-model="editForm.name" class="input_Box_medium" disabled>
              <el-option v-for="item in numberList" :key="item" :value="item" :label="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联产品">
            <el-select v-model="editForm.goods_id" placeholder="请选择产品" class="input_Box_medium">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disable"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.remark" class="input_Box_medium"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEdit = false">取 消</el-button>
          <el-button type="primary" @click="editSave">修 改</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { equipmentAdd, equipmentDel, equipmentEdit, equipmentList, goodsOptions } from "@/api/vip";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {},
  data() {
    return {
      tableList: [], //列表
      keyword: "",
      page: 1,
      total: 0,
      formData: {
        name: "",
        desc: ""
      },
      headerStyle: {
        background: "rgba(250,250,250,1)",
        color: "#000000"
      },
      editForm: {},
      showEdit: false,
      loading: true,
      loading2: false,
      equipName: "",
      addStatus: false,
      options: [], //关联产品列表
      numberList: [] //油枪号列表
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
      this.getipmentList();
    });
    this.numberList = new Array(61)
      .toString()
      .split(",")
      .map(function(item, index) {
        if(index == 60){
          return " ";
        }else {
          return index + 1 + "号油枪";
        }
      });
  },
  methods: {
    getData() {
      goodsOptions({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.options = res.data;
          } else {
            this.$message.error("暂无数据...");
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    getipmentList() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.keyword
      };
      equipmentList(data).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.tableList = res.data;
            this.total = res.total;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error("暂无数据....");
          }
        } else {
          this.loading = false;
          this.tableList = [];
          this.$message.error(res.msg);
        }
      });
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getipmentList();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getipmentList();
    },
    // 添加
    AddEquip() {
      this.addStatus = false;
      if (this.formData.name && this.formData.goods_id) {
        this.loading2 = true;
        var data = {
          token: this.token,
          app_id: this.app_id,
          name: this.formData.name,
          goods_id: this.formData.goods_id,
          remark: this.formData.remark
        };
        equipmentAdd(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
              success: () => {
                this.getipmentList();
              }
            });
            this.formData = { name: "", goods_id: "" };
            this.getipmentList();
          } else {
            this.$message.error(res.msg);
          }
          this.loading2 = false;
        });
      }
    },
    // 编辑保存
    editSave() {
      if (this.editForm.name) {
        this.loading2 = true;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.editForm.id,
          name: this.editForm.name,
          goods_id: this.editForm.goods_id,
          remark: this.editForm.remark
        };
        equipmentEdit(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.getipmentList();
          } else {
            this.$message.error(res.msg);
          }
          this.loading2 = false;
          this.showEdit = false;
        });
      }
    },
    // 修改
    editItem(row) {
      this.editForm = Object.assign({}, row);
      // console.log(this.editForm.name.replace(/[^\d]/g,' '))
      // this.editForm.name = this.editForm.name.replace(/[^\d]/g,' ');
      this.showEdit = true;
    },
    //删除
    delItem(i) {
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i
          };
          equipmentDel(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getipmentList();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch();
    },
    inputName(i) {
      if (i == 1) {
        this.formData.name = isNaN(Number(this.formData.name))
          ? ""
          : this.formData.name;
      } else if (i == 2) {
        this.editForm.name = isNaN(Number(this.editForm.name))
          ? ""
          : this.editForm.name;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../sub_com.scss";
.option {
  width: 100%;
  height: 70px;
  display: flex;
  padding-left: 10px;
  align-items: center;
  background: #ffffff;
}
// table
.el-table {
  box-shadow: 0 0 3px #f1f1f1;
  padding-left: 10px;
  height: 100%;
}
.add_box {
  box-shadow: 0 0 3px #f1f1f1;
  padding: 20px 20px 0 10px;
  height: 100%;
  .form_line {
    display: flex;
    div {
      margin: 0 10px;
    }
  }
}
.level_img {
  width: 60px;
  height: 60px;
}
//表格中的商品内容
.table_line {
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.input_Box_medium {
  width: 80%;
}
//分页
.Otherpage {
  width: 100%;
  height: 34px;
  line-height: 34px;
  background: #ffffff;
}
.dialog_box {
  margin: 0 50px;
  .bottom {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
